/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliMedicalRecordDtoApiResponse } from '../../models/amoxcalli-medical-record-dto-api-response';
import { AmoxcalliUpsertMedicalRecordDto } from '../../models/amoxcalli-upsert-medical-record-dto';

export interface ApiMedicalRecordsForParentPut$Json$Params {
  studentId?: string;
      body?: AmoxcalliUpsertMedicalRecordDto
}

export function apiMedicalRecordsForParentPut$Json(http: HttpClient, rootUrl: string, params?: ApiMedicalRecordsForParentPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliMedicalRecordDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, apiMedicalRecordsForParentPut$Json.PATH, 'put');
  if (params) {
    rb.query('studentId', params.studentId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliMedicalRecordDtoApiResponse>;
    })
  );
}

apiMedicalRecordsForParentPut$Json.PATH = '/api/medical-records/for-parent';
